module.exports = __webpack_public_path__ + "img/achievementBj.4c1c4049.png";